/* eslint-disable */
export const user = {
    id: 'cfaad35d-07a3-4447-a6c3-d8c3d54fd5df',
    username: 'bhughes',
    firstName: 'Brian',
    lastName: 'Hughes',
    email: 'hughes.brian@company.com',
    roles: ['admin'], // Array of roles - matches JWT structure
    avatar: 'images/avatars/brian-hughes.jpg',
    status: 'online',
};
